import { styled } from "@pigment-css/react";
import { useTranslations } from "@acto/web-common/locales";
import { ToggleGroup } from "../../../primitives";
import { CUSTOMER_METRICS, type CustomerMetric, useMetricLabels } from "../customerMetric";

const Wrapper = styled("div")({
  "& > [role='group']": {
    display: "flex",
    width: "100%",
  },
});

interface CustomerMetricSwitchProps {
  value: CustomerMetric;
  onChange: (metric: CustomerMetric) => void;
}

export const CustomerMetricSwitch = ({ value, onChange }: CustomerMetricSwitchProps) => {
  const t = useTranslations();
  const metricLabels = useMetricLabels();

  return (
    <Wrapper>
      <ToggleGroup
        options={CUSTOMER_METRICS.map((metric) => ({ value: metric, label: metricLabels[metric].label }))}
        value={value}
        onChange={(metric) => onChange(metric as CustomerMetric)}
        ariaLabel={t("managementView.customerDetails.metricSwitch")}
      />
    </Wrapper>
  );
};
